<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de atendimento domiciliar">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/atencao-basica/relatorio-atendimento-domiciliar/List'

export default {
    components: {List},
}
</script>